module.exports = __webpack_public_path__ + "96c58c0c18452f314839846f59e583d4.svg";